import {LiveScoreTimelineItem} from "../../../../../store/pages/liveScoreInfo/types";
import {GameEvent} from "../../../../../common/enums/gameEvents";
import {Icon} from "semantic-ui-react";
import React from "react";

export const renderIconForHomePlayer = (log: LiveScoreTimelineItem) => {
    if (log.homeAway) {
        switch (log.eventType) {
            case GameEvent.PlayerChanged: {
                return <Icon name="user" style={{ color: '#45e5e5' }}/>;
            }
            case GameEvent.LegWin: {
                return <Icon name="certificate" style={{ color: '#45e5e5' }}/>;
            }
            case GameEvent.WinSet: {
                return <Icon name="check square outline" style={{ color: '#45e5e5' }}/>;
            }
            case GameEvent.TurnFinished: {
                return <Icon name="location arrow" style={{ color: '#45e5e5' }}/>;
            }

            default:
                break;
        }
    }
};
export const renderIconForAwayPlayer = (log: LiveScoreTimelineItem) => {
    if (!log.homeAway) {
        switch (log.eventType) {
            case GameEvent.PlayerChanged: {
                return <Icon name="user"style={{ color: '#45e5e5' }}/>;
            }
            case GameEvent.LegWin: {
                return <Icon name="certificate"style={{ color: '#45e5e5' }}/>;
            }
            case GameEvent.WinSet: {
                return <Icon name="check square outline"style={{ color: '#45e5e5' }}/>;
            }
            case GameEvent.TurnFinished: {
                return <Icon name="location arrow" style={{ color: '#45e5e5' }}/>;
            }

            default:
                break;
        }
    }
};
